import {Component,OnInit,EventEmitter,Output} from '@angular/core';
import { PushNotificationService } from '../../services/notification/push-notification.service';
import { Notification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';

@Component({
    selector: 'app-push-notification',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.css']
})
/** push-notification component*/
export class PushNotificationComponent implements OnInit {
  public notificationList: Notification[];
  public title: string = 'Push Notifications!';
  public customerTypeId: number = 3;
  public userId: number = 1;// 3 is for vistor
  constructor(private _notificationService: PushNotificationService, private readonly notificationService: NotificationService) {
    this._notificationService.requestPermission();
  }
  ngOnInit() { }

  notify() {
    this.notificationService.GetPushNotification(this.customerTypeId,this.userId).subscribe(
      data => {
        this.notificationList = data;
        let notifications: Array<any> = [];
        for (var i = 0; i < this.notificationList.length; i++) {
          notifications.push({
            'title': this.notificationList[i].title == null ? "Notification" : this.notificationList[i].title,
            'alertContent': this.notificationList[i].notificationDetail
          });
        }
        this._notificationService.generateNotification(notifications);
      }
    )
   
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/push-notification/push-notification.component.ts